import React from 'react';

const ModalDealershipDetails = ({selectedMarker, clearSelectedMarker}) => {
    return (
        <div className="modal-dealership-details">
            <div className="modal-box-desktop">
                <div className="modal-header">
                    <div className="modal-close" onClick={clearSelectedMarker}>✕</div>
                    <h4><strong>{selectedMarker.name}</strong></h4>
                </div>

                <div className="modal-body">
                    <div className="modal-body-content">
                        <span>
                            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clipPath="url(#clip0_781_41217)">
                                    <path d="M8.9925 1.5C4.8525 1.5 1.5 4.86 1.5 9C1.5 13.14 4.8525 16.5 8.9925 16.5C13.14 16.5 16.5 13.14 16.5 9C16.5 4.86 13.14 1.5 8.9925 1.5ZM9 15C5.685 15 3 12.315 3 9C3 5.685 5.685 3 9 3C12.315 3 15 5.685 15 9C15 12.315 12.315 15 9 15ZM9.375 5.25H8.25V9.75L12.1875 12.1125L12.75 11.19L9.375 9.1875V5.25Z" fill="#B9C0C2"/>
                                </g>
                                <defs>
                                    <clipPath id="clip0_781_41217">
                                        <rect width="18" height="18" fill="white"/>
                                    </clipPath>
                                </defs>
                            </svg>
                            <p className="--text-s">Horarios de atención</p>
                        </span>
                        <p className="--text-s fw-300">{selectedMarker.open_hours}</p>
                    </div>

                    <div className="modal-body-content">
                        <span>
                            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clipPath="url(#clip0_781_41223)">
                                    <path d="M9 9C8.175 9 7.5 8.325 7.5 7.5C7.5 6.675 8.175 6 9 6C9.825 6 10.5 6.675 10.5 7.5C10.5 8.325 9.825 9 9 9ZM13.5 7.65C13.5 4.9275 11.5125 3 9 3C6.4875 3 4.5 4.9275 4.5 7.65C4.5 9.405 5.9625 11.73 9 14.505C12.0375 11.73 13.5 9.405 13.5 7.65ZM9 1.5C12.15 1.5 15 3.915 15 7.65C15 10.14 12.9975 13.0875 9 16.5C5.0025 13.0875 3 10.14 3 7.65C3 3.915 5.85 1.5 9 1.5Z" fill="#B9C0C2"/>
                                </g>
                                <defs>
                                    <clipPath id="clip0_781_41223">
                                        <rect width="18" height="18" fill="white"/>
                                    </clipPath>
                                </defs>
                            </svg>
                            <p className="--text-s">Dirección</p>
                        </span>
                        <p className="--text-s fw-300">{selectedMarker.address}</p>

                        <a className="btn-large btn-outline-black"href={`https://www.google.com/maps/search/?api=1&query=${selectedMarker.coords.lat},${selectedMarker.coords.lng}`} target="_blank">
                            ver en google maps
                        </a>
                    </div>

                    <div className="modal-body-content">
                        <span>
                            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clipPath="url(#clip0_781_41230)">
                                    <path d="M12.7501 0.7575L5.25007 0.75C4.42507 0.75 3.75757 1.425 3.75757 2.25V15.75C3.75757 16.575 4.42507 17.25 5.25007 17.25H12.7501C13.5751 17.25 14.2501 16.575 14.2501 15.75V2.25C14.2501 1.425 13.5751 0.7575 12.7501 0.7575ZM12.7501 14.25H5.25007V3.75H12.7501V14.25Z" fill="#B9C0C2"/>
                                </g>
                                <defs>
                                    <clipPath id="clip0_781_41230">
                                        <rect width="18" height="18" fill="white"/>
                                    </clipPath>
                                </defs>
                            </svg>
                            <p className="--text-s">Teléfono</p>
                        </span>
                        <a href={"tel:" + selectedMarker.phone_numbers}>
                            <p className="--text-s fw-300">{selectedMarker.phone_numbers}</p>
                        </a>
                    </div>
                </div>
            </div>

            <div className="modal-box-mobile">
                <div className="modal-header">
                    <h4><strong>{selectedMarker.name}</strong></h4>
                    <div className="modal-close" onClick={clearSelectedMarker}>✕</div>
                </div>

                <div className="modal-body">
                    <div className="modal-body-content">
                        <span>
                            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clipPath="url(#clip0_781_41217)">
                                    <path d="M8.9925 1.5C4.8525 1.5 1.5 4.86 1.5 9C1.5 13.14 4.8525 16.5 8.9925 16.5C13.14 16.5 16.5 13.14 16.5 9C16.5 4.86 13.14 1.5 8.9925 1.5ZM9 15C5.685 15 3 12.315 3 9C3 5.685 5.685 3 9 3C12.315 3 15 5.685 15 9C15 12.315 12.315 15 9 15ZM9.375 5.25H8.25V9.75L12.1875 12.1125L12.75 11.19L9.375 9.1875V5.25Z" fill="#B9C0C2"/>
                                </g>
                                <defs>
                                    <clipPath id="clip0_781_41217">
                                        <rect width="18" height="18" fill="white"/>
                                    </clipPath>
                                </defs>
                            </svg>
                            <p className="--text-s">Horarios de atención</p>
                        </span>
                        <p className="--text-s fw-300">{selectedMarker.open_hours}</p>
                    </div>

                    <div className="modal-body-content">
                        <span>
                            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clipPath="url(#clip0_781_41223)">
                                    <path d="M9 9C8.175 9 7.5 8.325 7.5 7.5C7.5 6.675 8.175 6 9 6C9.825 6 10.5 6.675 10.5 7.5C10.5 8.325 9.825 9 9 9ZM13.5 7.65C13.5 4.9275 11.5125 3 9 3C6.4875 3 4.5 4.9275 4.5 7.65C4.5 9.405 5.9625 11.73 9 14.505C12.0375 11.73 13.5 9.405 13.5 7.65ZM9 1.5C12.15 1.5 15 3.915 15 7.65C15 10.14 12.9975 13.0875 9 16.5C5.0025 13.0875 3 10.14 3 7.65C3 3.915 5.85 1.5 9 1.5Z" fill="#B9C0C2"/>
                                </g>
                                <defs>
                                    <clipPath id="clip0_781_41223">
                                        <rect width="18" height="18" fill="white"/>
                                    </clipPath>
                                </defs>
                            </svg>
                            <p className="--text-s">Dirección</p>
                        </span>
                        <p className="--text-s fw-300">{selectedMarker.address}</p>

                        <a className="btn-large btn-outline-black"href={`https://www.google.com/maps/search/?api=1&query=${selectedMarker.coords.lat},${selectedMarker.coords.lng}`} target="_blank">
                            ver en google maps
                        </a>
                    </div>

                    <div className="modal-body-content">
                        <span>
                            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clipPath="url(#clip0_781_41230)">
                                    <path d="M12.7501 0.7575L5.25007 0.75C4.42507 0.75 3.75757 1.425 3.75757 2.25V15.75C3.75757 16.575 4.42507 17.25 5.25007 17.25H12.7501C13.5751 17.25 14.2501 16.575 14.2501 15.75V2.25C14.2501 1.425 13.5751 0.7575 12.7501 0.7575ZM12.7501 14.25H5.25007V3.75H12.7501V14.25Z" fill="#B9C0C2"/>
                                </g>
                                <defs>
                                    <clipPath id="clip0_781_41230">
                                        <rect width="18" height="18" fill="white"/>
                                    </clipPath>
                                </defs>
                            </svg>
                            <p className="--text-s">Teléfono</p>
                        </span>
                        <a href={"tel:" + selectedMarker.phone_numbers}>
                            <p className="--text-s fw-300">{selectedMarker.phone_numbers}</p>
                        </a>
                    </div>

                </div>
            </div>
        </div>
    );
}

export default ModalDealershipDetails;